import type { LucideIcon } from "lucide-react";
import { NavLink } from "react-router";
import { clsx } from "@/src/common/utils/clsx";

interface SidebarItemProps {
	icon?: LucideIcon;
	label: React.ReactNode;
	to: string;
	badge?: React.ReactNode;
	end?: boolean;
}

/** Single sidebar row. Uses `NavLink` so the active state tracks the URL. */
export function SidebarItem({ icon: Icon, label, to, badge, end = false }: SidebarItemProps) {
	return (
		<NavLink
			to={to}
			end={end}
			className={({ isActive }) =>
				clsx(
					"group flex items-center gap-3 rounded-s px-3 py-2 text-sm font-medium transition-colors",
					isActive ? "bg-primary-subtle text-primary" : "text-muted-foreground hover:bg-surface hover:text-foreground",
				)
			}
		>
			{Icon ? <Icon className="size-4 shrink-0" aria-hidden /> : null}
			<span className="flex-1 truncate">{label}</span>
			{badge ? (
				<span className="inline-flex min-w-[20px] items-center justify-center rounded-pill bg-primary px-1.5 text-[11px] font-semibold text-primary-foreground">
					{badge}
				</span>
			) : null}
		</NavLink>
	);
}
